import {
  Box,
  Link,
  Stack,
  Container,
  SvgIcon,
  Typography,
  Tab,
  Tabs,
  Divider,
} from '@mui/material';
import { RouterLink } from 'src/components/router-link';
import { paths } from 'src/paths';
import ArrowLeftIcon from '@untitled-ui/icons-react/build/esm/ArrowLeft';
import { Outlet, useNavigate } from 'react-router';
import { useEffect, useState } from 'react';
import PatientUploadTable from './patient-upload-table';
import { useDispatch, useSelector } from 'react-redux';
import { resetValidationCSVTemplate } from 'src/redux/actions/patientAction';
import SimpleSnackbar from './details-page/sub-components/snackBar';

const { patients } = paths;
function PatientUpload() {
  const [activeTab, setActiveTab] = useState('validRecords');
  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue);
  };
  const [uploadData, setUploadData] = useState<any>();
  const validateCSVResponse = useSelector((state: any) => state.validateCSVTemplateReducer);

  useEffect(() => {
    setUploadData(validateCSVResponse?.response?.data);
  }, [validateCSVResponse]);

  const [patientError, setPatientError] = useState('');
  const [succesModal, setsuccesModal] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { patients } = paths;
  useEffect(() => {
    if (!validateCSVResponse.isValidationSuccess && validateCSVResponse.response === null) return;
    if (
      !validateCSVResponse.isValidationSuccess &&
      validateCSVResponse.response !== null &&
      validateCSVResponse?.response?.code != 'OK'
    ) {
      setPatientError(
        validateCSVResponse?.response?.message
          ? validateCSVResponse?.response?.message
          : 'Please Add Valid File'
      );
      setsuccesModal(true);

      setTimeout(() => {
        navigate(`${patients}`);
        setsuccesModal(false);
        dispatch(resetValidationCSVTemplate());
      }, 3000);
      return;
    }
    if (
      validateCSVResponse?.response?.data != null ||
      validateCSVResponse?.response?.code === 'OK'
    ) {
      setPatientError('');
    }

    return;
  }, [validateCSVResponse]);

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 8,
      }}
    >
      <Container maxWidth={'xl'}>
        <Stack spacing={4}>
          <Stack spacing={4}>
            <div>
              <Link
                color="text.primary"
                component={RouterLink}
                href={paths.patients}
                sx={{
                  alignItems: 'center',
                  display: 'inline-flex',
                }}
                underline="hover"
              >
                <SvgIcon sx={{ mr: 1 }}>
                  <ArrowLeftIcon />
                </SvgIcon>
                <Typography variant="subtitle2">Back to Patient List</Typography>
              </Link>
            </div>
            <Stack
              alignItems="flex-start"
              direction={{
                xs: 'column',
                md: 'row',
              }}
              justifyContent="space-between"
              spacing={4}
            >
              <Stack spacing={1}>
                <Typography variant="h4">Upload</Typography>
              </Stack>
            </Stack>
          </Stack>
          <div>
            <Tabs
              indicatorColor="primary"
              scrollButtons="auto"
              sx={{ mt: 3 }}
              textColor="primary"
              variant="scrollable"
              value={activeTab}
              onChange={handleTabChange}
            >
              <Tab
                key="validRecords"
                label={`Valid Records (${uploadData?.patientSuccessResponseList?.length || 0})`}
                value="validRecords"
              />
              <Tab
                key="invalidRecords"
                label={`InValid Records (${uploadData?.patientFailureResponseList?.length || 0})`}
                value="invalidRecords"
              />
            </Tabs>
            <Divider />
          </div>
          <Outlet />
          <PatientUploadTable
            source={activeTab}
            count={0}
            items={
              activeTab === 'validRecords'
                ? uploadData?.patientSuccessResponseList
                : uploadData?.patientFailureResponseList
            }
            validateCSVResponse={uploadData}
          />
        </Stack>
      </Container>

      {succesModal && (
        <SimpleSnackbar
          message={patientError}
          isError={!validateCSVResponse?.isValidationSuccess}
        />
      )}
    </Box>
  );
}

export default PatientUpload;
